import { Component } from '@angular/core';
import { GlobalService } from 'src/app/services/index.service';
import { HeaderService } from '../header.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-sidenavbar',
  templateUrl: './sidenavbar.component.html',
  styleUrls: ['./sidenavbar.component.scss']
})
export class SidenavbarComponent {
  constructor(
    public global:GlobalService,
    public sidenavService:HeaderService
  ) {}
  getStatus():boolean{
    return this.sidenavService.sidebarStatus
  }
  isOrganUser(){
    return this.global.checkUserIsOrganObs()
  }
  scrollToViewNavigate(){
    this.global.scrollToTopOfView('body')
  }
  isAfarine(){
    return this.global.isAfarine()
  }
  katibePathProduction(){
    if(environment.production && environment.mode.prod){
      return `/katibe/dima`
    }else{
      return '/katibe'
    }
  }
  profileRoute(){
    return this.global.profileRoute()
  }
}